// src/store/useUserStore.ts
import { create } from 'zustand';
import { persist, PersistStorage, StorageValue } from 'zustand/middleware';

import { AdvisorConnectResponse } from '@/api';

// Définir l'interface pour le typage du store
interface UserState {
  user: AdvisorConnectResponse | null;
  setUser: (user: AdvisorConnectResponse) => void;
  clearUser: () => void;
}

const customStorage: PersistStorage<UserState> = {
  getItem: (key: string): StorageValue<UserState> => {
    const storedValue = sessionStorage.getItem(key);
    return storedValue ? { state: JSON.parse(storedValue) as UserState } : { state: {} as UserState };
  },
  setItem: (key: string, value: StorageValue<UserState>) => {
    sessionStorage.setItem(key, JSON.stringify(value.state));
  },
  removeItem: (key: string) => {
    sessionStorage.removeItem(key);
  },
};

const userStore = create(
  persist<UserState>(
    (set) => ({
      user: null,
      setUser: (user) => set({ user }),
      clearUser: () => set({ user: null }),
    }),
    {
      name: 'user-storage',
      storage: customStorage,
    }
  )
);

export { userStore as useUserStore };
